import HelpIcon from './HelpIcon'
export default HelpIcon


// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/HelpIcon/index.js